module.exports = __webpack_public_path__ + "static/media/291351.ec7931da.png";